module.exports = __webpack_public_path__ + "static/media/street-glide-special-billiard-red.74051e68.png";